import { Mark, mergeAttributes } from '@tiptap/core'

/** Inline @mention styling in the chamber composer (primary blue). */
export const ComposerMention = Mark.create({
  name: 'composerMention',
  inclusive: false,
  excludes: '_',

  addAttributes() {
    return {
      id: { default: null },
      kind: { default: 'user' },
    }
  },

  parseHTML() {
    return [{ tag: 'span[data-composer-mention]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-composer-mention': '',
        class: 'composer-mention',
      }),
      0,
    ]
  },
})
